var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalyzeWidgetDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 84 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 49,
    fill: "#1A202C",
    rx: 8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 41,
    x: 4,
    y: 4,
    fill: "#28313F",
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#605CFF",
    d: "M17 13a1 1 0 1 1 2 0v26h-2V13ZM25 19a1 1 0 1 1 2 0v20h-2V19ZM33 25a1 1 0 1 1 2 0v14h-2V25ZM41 19a1 1 0 1 1 2 0v20h-2V19Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF6565",
    d: "M49 18a1 1 0 1 1 2 0v21h-2V18ZM57 13a1 1 0 1 1 2 0v26h-2V13ZM65 22a1 1 0 1 1 2 0v17h-2V22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyzeWidgetDark);
export default __webpack_public_path__ + "static/media/analyze-widget-dark.0c119512b2f317b51f23bf32c5f167fe.svg";
export { ForwardRef as ReactComponent };